export default __webpack_public_path__ + "static/media/vegDiet1.8fdfb9cc.jpg";